/**
 * adminWorkspaceAccounts.ts
 * 官方工作台账号列表 —— 真实员工 + 超管角色
 * 由超管授权，与管理员账号通用（不同角色的管理员）
 */

export type WorkspaceRole = 'super_admin' | 'real_staff' | 'sales';

export interface WorkspaceAccount {
  account: string;
  password: string;
  displayName: string;
  role: WorkspaceRole;
  title: string;
  avatar?: string;
}

/**
 * 官方工作台账号列表
 * 真实员工固定账号，由超管授权开通
 */
export const WORKSPACE_ACCOUNTS: WorkspaceAccount[] = [
  // ── 超管 ──────────────────────────────────────────────
  {
    account: 'admin',
    password: 'admin123',
    displayName: '超级管理员',
    role: 'super_admin',
    title: '超级管理员',
  },
  {
    account: 'admin01',
    password: 'admin123',
    displayName: '管理员01',
    role: 'super_admin',
    title: '系统管理员',
  },
  {
    account: 'admin02',
    password: 'admin123',
    displayName: '管理员02',
    role: 'super_admin',
    title: '系统管理员',
  },

  // ── 真实员工 ──────────────────────────────────────────
  {
    account: 'yang',
    password: 'Staff@2026',
    displayName: '杨先生',
    role: 'real_staff',
    title: '联合创始人',
  },
  {
    account: 'shi',
    password: 'Staff@2026',
    displayName: '石先生',
    role: 'real_staff',
    title: '技术负责人',
  },
  {
    account: 'li',
    password: 'Staff@2026',
    displayName: '李先生',
    role: 'real_staff',
    title: '运营负责人',
  },
  {
    account: 'staff01',
    password: 'Staff@2026',
    displayName: '内部员工01',
    role: 'real_staff',
    title: '内部员工',
  },
  {
    account: 'staff02',
    password: 'Staff@2026',
    displayName: '内部员工02',
    role: 'real_staff',
    title: '内部员工',
  },

  // ── 销售人员 ──────────────────────────────────────────
  {
    account: 'sales_wang',
    password: 'Sales@2026',
    displayName: '王芳',
    role: 'sales',
    title: '销售经理 · 华东区',
  },
  {
    account: 'sales_li',
    password: 'Sales@2026',
    displayName: '李明',
    role: 'sales',
    title: '销售经理 · 华南区',
  },
  {
    account: 'sales_zhao',
    password: 'Sales@2026',
    displayName: '赵磊',
    role: 'sales',
    title: '销售经理 · 西南区',
  },
  {
    account: 'sales_zhang',
    password: 'Sales@2026',
    displayName: '张伟',
    role: 'sales',
    title: '销售经理 · 华北区',
  },
  {
    account: 'sales01',
    password: 'Sales@2026',
    displayName: '销售专员01',
    role: 'sales',
    title: '销售专员',
  },
];

/** 验证官方工作台账号 */
export function validateWorkspaceAccount(account: string, password: string): WorkspaceAccount | null {
  return WORKSPACE_ACCOUNTS.find(
    a => a.account === account.trim() && a.password === password.trim()
  ) ?? null;
}

/** 根据账号名获取账号信息 */
export function getWorkspaceAccount(account: string): WorkspaceAccount | null {
  return WORKSPACE_ACCOUNTS.find(a => a.account === account.trim()) ?? null;
}
